<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>{{title}} 찾기</span><br/>
					휴대폰 본인인증을 해주세요.
				</div>
			</div>
		</div>
		<div class="mem_container">
			<div class="main-box">				
				<div class="mem_contents_body">
					<div class="info-box">
						<div class="contents-body-box">
							<p class="mb-10">휴대폰 본인인증</p>
							<div class="guide-text">
								<div v-if="title == '아이디'">휴대폰 인증 후 아이디를 확인할 수 있습니다.</div>
								<div v-else>휴대폰 인증 후 비밀번호를 재설정 할 수 있습니다.</div>
							</div>
							<div class="confirm-btn" @click="openCert()">
								휴대폰 본인인증 하기
							</div>
						</div>
					</div>
				</div>
			</div>			
		</div>
	</div>
</template>

<script>
import { findIdMeta } from '@/utils/meta';
import { findPwAuthMeta } from '@/utils/meta';
export default {
	data() {
		return {
			mberId : '',
			title : '아이디',
			kcpcert : {},
			mberDivCd : '',
			metaData : findIdMeta,
		}
	},

	beforeMount() {
		//console.log('ROUTE', this.$route);
		//console.log('PARAMETER', this.$route.params);

		if(Object.keys(this.$route.params).length > 0) {
			var viewNm = this.$route.name;

			if(viewNm == 'MEM002M05') {
				this.title = '비밀번호';
				this.mberId = this.$route.params.mberId;
				this.metaData = findPwAuthMeta;
			}else {
				this.mberDivCd = this.$route.params.mberDivCd;
			}
		}else {
			this.$router.replace({name : 'MEM001M01'});
		}
	},

	methods : {
		setForwardData() {
		},

		openCert() {
			this.$.kcpCert(this, function(this_obj, res) {
				this_obj.kcpcert = res;
				this_obj.memberChk();
			});

		},

		memberChk() {
			var param = this.kcpcert;
			if(this.mberId) param.mberId = this.mberId;
			if(this.mberDivCd) param.mberDivCd = this.mberDivCd;

			//console.log('MEMBER_CHK_REQ :', param);

			this.$.httpPost('/api/mem/memberChk', param, '')
				.then(res => {
					// console.log('result :', res);

					if(res.data.resultCode == '000') {
						if((this.title == '아이디' && res.data.idMap) || (this.title == '비밀번호' && res.data.idMap && res.data.idMap.kakaoYn == 1)) {
							this.pageMove(res.data.idMap.mberId);
						} else if (this.title == '비밀번호' && res.data.idMap && res.data.idMap.kakaoYn == 0) {
							alert('카카오 간편가입 회원입니다. 비밀번호를 변경할 수 없습니다.');
						} else {
							if(this.title == '아이디') {
								alert('가입된 아이디를 찾을 수 없습니다.');
							} else {
								alert('본인인증 내역과 아이디가 일치하지 않습니다.');
							}
						}
					}
				});
		},

		pageMove(id) {
			var scrNm = 'MEM002M04';
			if(this.title == '비밀번호') scrNm = 'MEM002M03';

			var param = {
				title : this.title,
				mberId : id
			}

			this.$router.push({name:scrNm, params:{forwardData : param}});
		}
	},
	metaInfo() {
		return this.metaData;
	},
}
</script>